import { IReport6RiskCriteria } from "../../../model/report/Report6RiskCriteria";

export interface TReport6RiskCriteriaPresentationModel {
  name: string;
  reportId: number;
}

const Report6RiskCriteriaPresentationModel = (
  data: IReport6RiskCriteria
): TReport6RiskCriteriaPresentationModel => {
  return { ...data };
};

export default Report6RiskCriteriaPresentationModel;
